const QueryConstants = {
    ENCODED_ALIAS: 'encodedAlias',
    VERIFICATION_TOKEN: 'verificationToken',
    EMAIL_VERIFICATION: 'emailVerification',
    MARKETING_PATH: 'mktPath',
    POSTING_PATH: 'postingPath',
    SECURITY_TOKEN: 'securityToken',
    SIGN_IN_LP: 'signInLP',
    AD: 'ad',
    ARCHIVED: 'archived',
    HAS_SUCCESS_REDIRECT_PATH: 'hasSuccessRedirectPath',
};

export default QueryConstants;
